import _ from 'lodash';
import delegate from './nativeDelegate';
//import EventEmitter from './event';
import {EventEmitter} from 'events';

/**
 * chrome book 硬件全局适配类，将蓝牙、wifi、hid全部抽象成串口，对外提供无差别连接
 *
 * @class ChromeHardwareClient
 */
class NativeHardwareClient {
    constructor() {

    }

    getChannelConnected() {
        return delegate.getConnected();
    }

    addListener(connectType, method, callback) {
        let cb = (message) => {
            callback(message.error, message.data);
        }
        delegate.createListeners(connectType, method, cb);
    }

    removeListener(connectType, method) {
        delegate.destroyListeners(connectType, method);
    }

    sendMessage(message, callback) {
        delegate.sendMessage(message, callback);
    }
}

let inst = new NativeHardwareClient();


/**
 *
 * node serialport
 * @class SerialPort
 */
class SerialPort extends EventEmitter {

    /**
     *Creates an instance of SuperSerialPort.
     * @param {string} path
     * @param {*} options {connectType:<serialport | ble | hid>, baudRate:115200}
     * @param {*} callback
     * @memberof SerialPort
     */
    constructor(path, options, callback) {
        super();
        this.connectType = 'serialport';
        this.options = options;
        if (!options) {
            this.options = {
                connectType: this.connectType,
                baudRate: 115200,
            };
        }

        this.options.port = path;
        delegate.createListeners('serialport', 'onReceive', (message) => {
            if (!message.error) {
                this.emit('data', message.data);
            } else if (message.error === 'disconnect') {
                console.log('serialport disconnect.');
                this.emit('disconnect', message.error, this.isOpen);
                this.isOpen = false;
            } else if (message.error === 'close') {
                console.log('serialport close.');
                this.emit('disconnect', message.error, this.isOpen);
                this.isOpen = false;
            } else {
                console.log('serialport error.');
                this.emit('error', message.error, this.isOpen);
                this.isOpen = false;
            }
        });
        delegate.addDisconnectListener((message) => {
            this.emit('disconnect', message, this.isOpen);
            this.isOpen = false;
        });
        if (_.isFunction(callback)) {
            callback();
        }
        this.isOpen = false;
    }

    /**
     *
     * 列举所有串口
     * @static
     * @param {*} type
     * @param {*} callback
     * @memberof SuperSerialPort
     */
    static list(type, callback) {

        delegate.sendMessage({
            connectType: 'serialport',
            cmd: 'getDevices',
            params: {options: this.options}
        }, (err, data) => {
            if (err) {
                return callback(err, []);
            }
            let result = [];
            data.forEach((v) => {
                if (!v.productId) {
                    console.log('Product id is null, omit this serialport');
                    return;
                }
                v.manufacturer = v.manufacturer || '';
                result.unshift(v);
            });
            callback(err, result);
        });
    }

    open(callback) {
        let cb = (err) => {
            if (err) {
                this.isOpen = false;
            } else {
                this.isOpen = true;
            }
            callback(err);
        };
        delegate.sendMessage({connectType: this.connectType, cmd: 'open', params: {options: this.options}}, cb);
    }

    close(callback) {
        return new Promise(resolve => {
            delegate.sendMessage({
                connectType: this.connectType,
                cmd: 'close',
                params: {options: this.options}
            }, (err, data) => {
                this.emit('disconnect', err, this.isOpen);
                this.isOpen = false;
                if (_.isFunction(callback)) {
                    callback(err, data);
                }
                resolve();
            });
        });
    }

    write(data, encode, callback) {
        return new Promise(resolve => {
            delegate.sendMessage({
                connectType: this.connectType,
                cmd: 'write',
                params: {options: this.options, data: data, encode: encode}
            }, (err, data) => {
                if ('disconnect' === err) {
                    this.emit('disconnect', err, this.isOpen);
                    this.isOpen = false;
                }
                if (_.isFunction(callback)) {
                    callback(err, data);
                }
                resolve();
            });
        });
    }

    set(data, callback) {
        return new Promise(resolve => {
            delegate.sendMessage({
                connectType: this.connectType,
                cmd: 'set',
                params: {options: this.options, data: data}
            }, (err, data) => {
                if ('disconnect' === err) {
                    this.emit('disconnect', err, this.isOpen);
                    this.isOpen = false;
                }
                if (_.isFunction(callback)) {
                    callback(err, data);
                }
                resolve();
            });
        });
    }

    drain(callback) {
        return new Promise(resolve => {
            delegate.sendMessage({
                connectType: this.connectType,
                cmd: 'drain',
                params: {options: this.options}
            }, (err, data) => {
                if ('disconnect' === err) {
                    this.emit('disconnect', err, this.isOpen);
                    this.isOpen = false;
                }
                if (_.isFunction(callback)) {
                    callback(err, data);
                }
                resolve();
            });
        });
    }

    flush(callback) {
        return new Promise(resolve => {
            delegate.sendMessage({
                connectType: this.connectType,
                cmd: 'flush',
                params: {options: this.options}
            }, (err, data) => {
                if ('disconnect' === err) {
                    this.emit('disconnect', err, this.isOpen);
                    this.isOpen = false;
                }
                if (_.isFunction(callback)) {
                    callback(err, data);
                }
                resolve();
            });
        });
    }

}

function getInstance(){
    let channel = inst;
    return {channel,SerialPort};
}
export {
    getInstance as default
};

